<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['产品管理', title + '达人']"/>
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form
                ref="form"
                class="add-form"
                :rules="rules"
                :model="form"
                label-width="140px"
            >
              <el-form-item label="达人名称：" prop="name">
                <el-input v-model="form.name"></el-input>
              </el-form-item>
              <el-form-item label="达人图片：" prop="photo">
                <uploadImage @success="getPicture" :img="pictureList" :limit="20"/>
              </el-form-item>
              <el-form-item label="视频：" prop="videoUrl">
                <videoUpload @success="getVideo" :list="videoList"/>
              </el-form-item>
              <el-form-item label="达人介绍：" prop="introduction">
                <editor :content="form.introduction" ref="editor"   @setHtml="setHtml" />
              </el-form-item>
              <el-form-item label="一级类目：" prop="oneList">
                <el-checkbox-group
                    v-model="form.oneList"
                    @change="oneChange"
                    :max="3"
                >
                  <template v-for="(item, index) in selectCategoryList">
                    <el-checkbox disabled :label="item.id" :key="index">{{
                        item.name
                      }}
                    </el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="二级类目：" prop="secondCategory">
                <el-checkbox-group v-model="testList" :max="5" @change="twoChange">
                <span style="margin-right: 30px" v-for="(item, index) in twoList" :key="index">
                  <template v-for="(i, inx) in item.data">
                    <el-checkbox :label="i.id" :key="inx">{{i.name }}
                    </el-checkbox>
                  </template>
                </span>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="达人类型：" prop="talentType">
                <el-radio-group v-model="form.talentType">
                  <el-radio :label="item.id" v-for="item in talentTypeList" :key="item.id" style="margin-bottom: 10px">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="肖像授权证明：">
                <div style="color: #606266">1.请按照模板格式准备证明材料，并盖章上传：</div>
                <el-button size="small" icon="el-icon-download" type="primary" @click="downloadMb">下载模板</el-button>
                <div style="color: #606266">2.上传盖章好的文件：</div>
                <FileUpload @success="getUrl" :list="authCertificateList" accept="" />
              </el-form-item>
              <el-form-item label="授权有效期：" prop="lifespan">
                <el-date-picker style="width: 100%" v-model="form.lifespan" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="全网粉丝量" prop="fansNum">
                <el-input v-model="form.fansNum" @input="getNumber"></el-input>
              </el-form-item>
              <el-form-item label="排序：" prop="sort">
                <el-input-number v-model="form.sort" :min="0" style="width: 100%"></el-input-number>
              </el-form-item>
              <el-form-item label="驳回原因：" v-if="form.status === '3'">
                <p class="reject-text">{{ form.reason }}</p>
              </el-form-item>
              <el-form-item class="hitKeyItem" label="违规词语：" v-if="form.hitKeyWords">
                <span class="hitKey_item">{{ form.hitKeyWords }}</span>
              </el-form-item>
              <el-form-item class="hitKeyItem" label="违规视频：" v-if="form.hitVideoUrl">
                <div v-for="item in hitVideoUrlList" :key="item" class="hitVideoBox">
                  <span :title="item" class="hitKey_item">{{ item }}</span>
                  <el-button @click="playVideo(item)" type="primary" size="mini" style="margin-right: 6px">播放
                  </el-button>
                  <el-button @click="deleteItem(item, 'video')" type="danger" size="mini">删除</el-button>
                </div>
              </el-form-item>
              <el-form-item class="hitKeyItem" label="违规图片：" v-if="tableData.length">
                <el-table :data="tableData" border>
                  <el-table-column prop="garbageText" align="center" show-overflow-tooltip label="违规内容">
                  </el-table-column>
                  <el-table-column prop="imgUrl" align="center" label="图片">
                    <template v-slot="scope">
                      <el-image v-if="scope.row.imgUrl" style="height: 100px" :src="scope.row.imgUrlSrc"
                                :preview-src-list="scope.row.imgUrlList" fit="contain"></el-image>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-form>

            <div class="info-footer">
              <el-button type="primary" @click="save">确定</el-button>
              <el-button @click="back">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>

    <el-dialog class="video-dialog" :visible.sync="visible" width="600px" @close="closeVideo">
      <video
          :src="videoSrc"
          controls
          class="video-box"
          ref="video">
      </video>
    </el-dialog>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'
import uploadImage from '../../components/xcUpload.vue'
import editor from '../../components/editor.vue'
import videoUpload from '../../components/videoUpload'
import FileUpload from '../../components/fileUpload'

export default {
  data () {
    return {
      loading: true,
      id: '',
      companyId: '',
      title: '添加',
      form: {
        id: '',
        photo: '',
        providerId: '',
        details: '',
        newProducts: '0',
        firstCategory: '',
        oneList: [],
        secondCategory: '',
        twoList: [],
        banner: '',
        sendSample: '',
        fansNum: '',
        talentType: '',
        authCertificate: '',
        lifespan: '',
        introduction: ''
      },
      pictureList: [],
      videoList: [],
      rules: {
        name: {
          required: true,
          message: '请输入中文名',
          trigger: 'blur'
        },
        photo: {
          required: true,
          message: '请上传达人图片',
          trigger: 'blur'
        },
        introduction: {
          required: true,
          message: '请输入达人介绍',
          trigger: 'blur'
        },
        talentType: {
          required: true,
          message: '请选择达人类型',
          trigger: 'blur'
        },
        lifespan: {
          required: true,
          message: '请选择授权有效期',
          trigger: 'blur'
        },
        fansNum: {
          required: true,
          message: '请输入全网粉丝量',
          trigger: 'blur'
        },
        oneList: {
          required: true,
          message: '请选择一级品类',
          trigger: 'blur'
        },
        sendSample: {
          required: true,
          message: '请选择寄样功能',
          trigger: 'blur'
        },
        secondCategory: {
          required: true,
          message: '请选择二级品类',
          trigger: 'blur'
        }
      },
      selectCategoryList: [],
      brandCategoryList: [],
      twoList: [],
      twoData: [],
      sendSamples: [
        {
          name: '可以寄样',
          id: '1'
        },
        {
          name: '可以参观/看样',
          id: '2'
        },
        {
          name: '可供产品资料',
          id: '3'
        },
        {
          name: '以上都不支持',
          id: '4'
        }
      ],
      dialogShow: false,
      verifyForm: {
        status: '2',
        reason: ''
      },
      verifyRules: {
        status: {
          required: true,
          message: '请选择状态!',
          trigger: 'change'
        },
        reason: {
          required: true,
          message: '请输入原因',
          trigger: 'blur'
        }
      },
      checkList: [],
      selectCheckList: [],
      hitImgUrlList: [],
      hitVideoUrlList: [],
      visible: false,
      videoSrc: '',
      serviceInfo: {
        fullName: '',
        status: 0,
        reason: ''
      },
      tableData: [],
      isDr: false,
      talentTypeList: [
        {
          name: '综合',
          id: '1'
        },
        {
          name: '美妆护肤',
          id: '2'
        },
        {
          name: '种草测评',
          id: '3'
        },
        {
          name: '个护家清',
          id: '4'
        },
        {
          name: '食品饮料',
          id: '5'
        },
        {
          name: '颜值剧情',
          id: '6'
        },
        {
          name: '时尚穿搭',
          id: '7'
        },
        {
          name: '本地生活',
          id: '8'
        },
        {
          name: '影视娱乐',
          id: '9'
        },
        {
          name: '游戏',
          id: '10'
        },
        {
          name: '数码科技',
          id: '11'
        },
        {
          name: '宠物',
          id: '12'
        },
        {
          name: '母婴',
          id: '13'
        },
        {
          name: '生活vlog',
          id: '14'
        },
        {
          name: '旅行',
          id: '15'
        },
        {
          name: '动漫',
          id: '16'
        },
        {
          name: '知识分享',
          id: '17'
        },
        {
          name: '手工',
          id: '18'
        },
        {
          name: '家居',
          id: '19'
        },
        {
          name: '汽车',
          id: '20'
        }
      ],
      authCertificateList: [],
      testList: []
    }
  },
  components: {
    navHeader,
    uploadImage,
    editor,
    videoUpload,
    FileUpload
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'cyberStar') {
      sessionStorage.removeItem('currentPage')
      sessionStorage.removeItem('pageSize')
      sessionStorage.removeItem('chineseName')
      sessionStorage.removeItem('fullName')
      sessionStorage.removeItem('status')
      sessionStorage.removeItem('sendSample')
      sessionStorage.removeItem('address')
      sessionStorage.removeItem('category')
      sessionStorage.removeItem('firstCategory')
      sessionStorage.removeItem('secondCategory')
      sessionStorage.removeItem('auditType')
      sessionStorage.removeItem('reviewedById')
      sessionStorage.removeItem('shelfStatus')
      sessionStorage.removeItem('orderData')
    }
    next()
  },
  created () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
    } else {
      this.id = ''
    }
    if (this.$route.params.type) {
      this.type = this.$route.params.type
      this.title = '编辑'
    } else {
      this.type = 'add'
      this.loading = false
      this.title = '添加'
    }
    this.getBrandCategoryList()
    this.getSelectCheckList()
  },
  mounted () {
    if (this.title === '添加') this.$refs.editor.initEditor()
  },

  methods: {
    getDetail (id) {
      this.$http.post('/cyberStar/getById', {id}).then(res => {
        if (res.data.code === '200') {
          this.form = res.data.data
          this.$refs.editor.initEditor(this.form.introduction)
          this.tableData = JSON.parse(JSON.stringify(res.data.data.garbageImage)) || []
          this.tableData.forEach(item => {
            if (item.imgUrl) {
              item.imgUrlList = item.imgUrl.split(',')
              item.imgUrlSrc = item.imgUrl.split(',')[0]
            } else {
              item.imgUrlSrc = ''
              item.imgUrlList = []
            }
          })
          this.getServiceAuditInfo(this.form.companyId)
          this.videoList = []
          let list = this.form.videoUrl ? this.form.videoUrl.split(',') : []
          list.forEach(item => {
            this.videoList.push({name: item, url: item})
          })
          this.authCertificateList = []
          let list1 = this.form.authCertificate ? this.form.authCertificate.split(',') : []
          list1.forEach(item => {
            this.authCertificateList.push({name: item, url: item})
          })
          this.form.newProducts = res.data.data.newProducts ? res.data.data.newProducts : '0'
          this.pictureList = this.form.photo ? this.form.photo.split(',') : []
          this.hitImgUrlList = this.form.hitImgUrl ? this.form.hitImgUrl.split(',') : []
          this.hitVideoUrlList = this.form.hitVideoUrl ? this.form.hitVideoUrl.split(',') : []
          this.testList = res.data.data.secondCategory ? res.data.data.secondCategory.split(',') : []
          this.getService()
        }
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.loading = false
      })
    },
    async getServiceAuditInfo (id) {
      let {data: res} = await this.$http.post('/company/getById', {id, type: '5'})
      this.serviceInfo.fullName = res.data.fullName
      this.serviceInfo.status = res.data.status
      this.serviceInfo.reason = res.data.reason
    },
    getService () {
      this.$http.get('/company/getByTalentOrgCompany/' + this.id).then(res => {
        if (res.data.code === '200') {
          this.form.oneList = res.data.data.firstCategory ? res.data.data.firstCategory.split(',') : []
          this.form.oneList.forEach((item) => parseInt(item))
          this.isDr = this.form.oneList.includes('205') || this.form.oneList.includes('206')
          this.twoList = []
          this.brandCategoryList.forEach((item) => {
            this.form.oneList.forEach((i) => {
              if (i === item.id) {
                this.selectCategoryList.push({
                  name: item.name,
                  id: item.id
                })
                this.twoList.push({
                  name: item.name,
                  id: item.id,
                  data: item.childList
                })
                console.log(this.twoList)
                let two = item.childList.map((n) => n.id)
                this.twoData.push(two.join(','))
              }
            })
          })
        }
      })
    },
    getBrandCategoryList () {
      this.$http.post('/brandCategory/getCategoryByType', {type: 5}).then(res => {
        if (res.data.code === '200') {
          this.brandCategoryList = res.data.data
          console.log(this.id)
          if (this.id) {
            this.getDetail(this.id)
          } else {
            this.getService()
          }
        }
      })
    },
    getSelectCheckList () {
      this.$http
        .post('/auditReason/getList', {type: '3'})
        .then((res) => {
          if (res.data.code === '200') {
            this.selectCheckList = res.data.data
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    oneChange () {
      this.twoList = []
      this.twoData = []
      this.brandCategoryList.forEach((item) => {
        this.form.oneList.forEach((i) => {
          if (i === item.id) {
            this.twoList.push({
              name: item.name,
              id: item.id,
              data: item.childList.map((n) => n.name)
            })
            let two = item.childList.map((n) => n.id)
            this.twoData.push(two.join(','))
          }
        })
      })
    },
    twoChange () {
      this.form.secondCategory = this.testList.join(',')
    },
    getUrl (list) {
      this.form.authCertificate = list.map(item => item.url).join(',')
    },
    getPicture (list) {
      this.form.photo = list.join(',')
    },
    getVideo (list) {
      this.form.videoUrl = list.map(item => item.url).join(',')
    },
    setHtml (html) {
      this.form.introduction = html
    },
    back () {
      this.$router.push('/cyberStar')
    },
    save () {
      this.$refs.form.validate(val => {
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.firstCategory = this.form.oneList.join(',')
          delete params.oneList
          const url = this.type === 'add' ? '/cyberStar/add' : '/cyberStar/update'
          this.$http.post(url, params).then(res => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.$router.push('/cyberStar')
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(e => {
            console.log(e)
          })
        }
      })
    },
    // checkbox改变
    checkChange (val) {
      this.verifyForm.reason = val.join(',')
    },
    verifySelect () {
      this.verifyForm.reason = ''
    },
    verify () {
      this.dialogShow = true
      this.checkList = []
      this.verifyForm.status = this.form.status
      this.verifyForm.reason = this.form.reason
    },
    confirm () {
      this.$refs.verifyForm.validate((val) => {
        if (val) {
          if (this.verifyForm.status !== '3') {
            this.verifyForm.reason = ''
          }
          this.$http
            .post('/cyberStar/audit', {ids: this.id, ...this.verifyForm})
            .then((res) => {
              if (res.data.code === '200') {
                this.$message.success('审核成功!')
                this.$router.back()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {
              this.$message({
                type: 'error',
                message: '审核失败'
              })
            })
          this.dialogShow = false
        }
      })
    },
    cancel () {
      this.dialogShow = false
      this.verifyForm = {
        status: '',
        reason: ''
      }
    },
    playVideo (url) {
      this.visible = true
      this.videoSrc = url
    },
    closeVideo () {
      this.videoSrc = ''
    },
    deleteItem (url, type) {
      let data = new FormData()
      data.append('url', url)
      this.$http.post('deleteGarbageFile', data).then(res => {
        if (res.data.code === '200') {
          this.$message.success(res.data.msg)
          if (type === 'video') {
            this.hitVideoUrlList.forEach((item, index) => {
              if (item === url) {
                this.hitVideoUrlList.splice(index, 1)
              }
            })
            this.form.hitVideoUrl = this.hitVideoUrlList.join(',')
            console.log(this.form.hitVideoUrl)
          } else {
            // this.hitImgUrlList
            this.hitImgUrlList.forEach((item, index) => {
              if (item === url) {
                this.hitImgUrlList.splice(index, 1)
              }
            })
            this.form.hitImgUrl = this.hitImgUrlList.join(',')
            console.log(this.form.hitImgUrl)
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    downloadMb () {
      window.location.href = 'https://oss.cbebaiwen.com/exhibitionUpload/630b04ee72b240ef94bccc7e16729e5e.docx'
    },
    getNumber (val) {
      this.form.fansNum = val.replace(/[^0-9]/g, '')
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/cyberStar/detail.vue